import { render } from "./HalfWorkdayIcon.vue?vue&type=template&id=5fa17312"
import script from "./HalfWorkdayIcon.vue?vue&type=script&lang=js"
export * from "./HalfWorkdayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__